import ea from "./in-app-message-manager.js";
import r from "../managers/braze-instance.js";
const je = {
  na: null,
  i: !1,
  ra: () => (
    je.t(), je.na || (je.na = new ea(r.m(), r.u(), r.p(), r.ir())), je.na
  ),
  t: () => {
    je.i || (r.g(je), (je.i = !0));
  },
  destroy: () => {
    (je.na = null), (je.i = !1);
  },
};
export default je;
